export interface IZilPayProviderOptions {

}

export default async (ZilPayProvider: any, options: IZilPayProviderOptions) => {
    return "ZilPay Porvider";
}